// assets/edm-shared-utils.js
window.EDM_UTILS = {
  // Zentraler Cart Fetcher (mit Cache-Optionen wenn nötig)
  getCart: async () => {
    const res = await fetch(window.Shopify.routes.root + 'cart.js', { cache: 'no-store' });
    return await res.json();
  },

  // Zentrales Update
  updateCart: async (updates) => {
    return await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ updates })
    });
  },
  
  // Refresh Helper
  refreshUI: () => {
     document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
     // Kompatibilität zu Themes
     if (window.EDUMON && window.EDUMON.refreshSections) window.EDUMON.refreshSections();
  }
};